import styled from "styled-components";
import { Button, Theme } from "@screencloud/screencloud-ui-components";
import { StyledContainer } from "../styles";

export const Styled = styled(StyledContainer)`
  background-color: var(--color-purple-950, #2e1a4c);
  color: var(--color-background, #fff);
  gap: 20px;
  padding-block: 10px;

  @media screen and (max-width: ${Theme.break.small}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const StyledMessageContainer = styled.span`
  font-size: var(--font-size-md, 16px);
  font-weight: 400;
  line-height: var(--font-line-height-md, 24px);

  strong {
    font-weight: 700;
  }

  @media screen and (max-width: ${Theme.break.small}) {
    font-size: var(--font-size-sm, 14px);
  }
`;

export const StyledButton = styled(Button)`
  &.button {
    background-color: var(--color-background, #fff);
    border: 1px solid var(--color-border, #c5c6ca);
    border-radius: var(--radius-md, 8px);
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
    color: var(--color-foreground, #404145);
    font-size: var(--font-size-sm, 14px);
    font-weight: 700;

    &:hover {
      background-color: var(--color-background, #fff);
      color: var(--color-foreground, #404145);
      border: 1px solid var(--color-border, #c5c6ca);
    }
  }
`;
